<script>
  import { currMenu, systemLog } from "../editor/storage.js";
  import { openSystemTooltip, closeSystemTooltip } from "../editor/utility.js";

  export let clickFunction;
  export let kbFunction;
  export let preventKeyboardAction = false;
</script>

<!-- keyboard shortcut listener -->
<svelte:body
  on:keypress={(event) => {
    if (!preventKeyboardAction) {
      if (event.key == ",") kbFunction(event, "preview");
      else if (event.key == ".") kbFunction(event, "preference");
      else if (event.key == "h") kbFunction(event, "exploration_history");
      else if (event.key == "s") kbFunction(event, "export");
      $systemLog.log({ message: "Used a shortcut", key: event.key });
    }
  }} />

<!-- Settings -->
<div>
  <section class="first-menu-section c">
    <button
      class={"icon-menu" + ($currMenu === "preview" ? " selected" : "")}
      type="button"
      aria-roledescription="Device preview (,)"
      on:click={(event) => {
        clickFunction(event, "preview");
      }}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-play-fill" />
    </button>
    <button
      class={"icon-menu" + ($currMenu === "preference" ? " selected" : "")}
      type="button"
      aria-roledescription="Preferences (.)"
      on:click={(event) => clickFunction(event, "preference")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-toggles" />
    </button>
    <button
      class={"icon-menu" +
        ($currMenu === "exploration_history" ? " selected" : "")}
      type="button"
      aria-roledescription="See exploration history (h)"
      on:click={(event) => clickFunction(event, "exploration_history")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-receipt" />
    </button>
    <button
      class={"icon-menu" + ($currMenu === "export" ? " selected" : "")}
      type="button"
      aria-roledescription="Import/export (s)"
      on:click={(event) => clickFunction(event, "export")}
      on:mouseover={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:mousemove={function (event) {
        openSystemTooltip(event, this.getAttribute("aria-roledescription"));
      }}
      on:focus={() => closeSystemTooltip()}
      on:blur={() => closeSystemTooltip()}
      on:mouseout={() => closeSystemTooltip()}
    >
      <i class="bi bi-folder2" />
    </button>
  </section>
  <div id="settingHelper" class="hoverHelper" style="z-index: 9999" />
</div>

<style>
  @media screen and (max-height: 760px) {
    section.c {
      border-top: 1px solid #dddddd;
      padding-top: 0.5rem;
      margin-top: 0 !important;
    }
  }
</style>
